export default __webpack_public_path__ + "static/media/spin-loader.19c08a21.svg";